module.exports = __webpack_public_path__ + "static/media/slider_image.d886b1cc.png";